var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFlight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.64736 19.3893L5.20903 14.7856L0.582031 12.324L1.84553 11.0675L5.87286 11.7523L9.4312 8.19398L0.678865 4.45831L2.2982 2.84831L12.944 4.67415L16.584 1.01198C16.9107 0.684535 17.3113 0.520813 17.7857 0.520813C18.2601 0.520813 18.6607 0.684535 18.9874 1.01198C19.3156 1.33942 19.4797 1.7392 19.4797 2.21131C19.4797 2.68342 19.316 3.0832 18.9885 3.41065L15.3194 7.05648L17.1464 17.6965L15.52 19.3228L11.7995 10.5705L8.2412 14.1288L8.9097 18.127L7.64736 19.3893Z",
    fill: "#000636"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlight);
export default __webpack_public_path__ + "static/media/flight.671d55571ec08f178a1429647309fc83.svg";
export { ForwardRef as ReactComponent };